export const translations = {
  en: {
    // Header
    home: 'Home',
    services: 'Services',
    testimonials: 'Testimonials',
    pricing: 'Pricing',
    faq: 'FAQ',
    login: 'Login',
    signup: 'Sign Up',
    language: 'עברית',
    personalArea: 'Personal Area',

    // Hero Section
    heroTitle: 'Your RSVP Solution',
    heroSubtitle: 'Simplify guest management for any event',
    getStarted: 'Get Started',
    learnMore: 'Learn More',

    // Services Section
    servicesTitle: 'Our Services',
    serviceRSVP: 'RSVP Management',
    serviceRSVPDesc: 'Track guest responses and manage attendance with ease',
    serviceCommunication: 'Guest Communication',
    serviceCommunicationDesc:
      'Send messages to guests before and after the event',
    serviceGifts: 'Digital Gift Registry',
    serviceGiftsDesc: 'Manage gift options and payment methods for your event',
    serviceAnalytics: 'Guest Analytics',
    serviceAnalyticsDesc:
      'Get insights about your guests and their preferences',

    // Testimonials
    testimonialsTitle: 'What Our Customers Say',
    testimonial1Text:
      '"The most incredible wedding planning service. Everything was perfect!"',
    testimonial1Author: '- Sarah & Michael',
    testimonial2Text:
      '"We loved how easy it was to track our RSVPs. The automated system saved us so much time!"',
    testimonial2Author: '- David & Emily',
    testimonial3Text:
      '"Our guests were impressed by how smooth the RSVP process was. Highly recommended!"',
    testimonial3Author: '- Rachel & James',

    // Pricing
    pricingTitle: 'Choose Your Plan',
    basic: 'Basic',
    pro: 'Professional',
    enterprise: 'Enterprise',
    monthly: 'Monthly',
    priceFree: 'Free',
    priceBasic: '$29',
    pricePro: '$99',
    perMonth: '/month',
    getStartedNow: 'Get Started Now',
    contactUs: 'Contact Us',

    // Join Section
    joinTitle: 'Ready to Simplify Your Event Planning?',
    joinSubtitle:
      'Sign up today and start managing your guest list effortlessly',
    joinButton: 'Join Now',

    // FAQ
    faqTitle: 'Frequently Asked Questions',
    faqQuestion1: 'How does the RSVP system work?',
    faqAnswer1:
      "Whether you choose SMS or WhatsApp, all responses are collected in your dashboard — a guest table showing who's coming, who isn't, and who hasn't answered yet, along with a pie chart of the breakdown. Special requests like transport are tracked there too.",
    faqQuestion2: 'Can I customize the invitation message?',
    faqAnswer2:
      'With SMS, yes — you can fully customize the messages sent to your guests. With WhatsApp, the bot follows a conversational flow, so the wording is fixed and cannot be edited.',
    faqQuestion3: 'Is there a limit to how many guests I can invite?',
    faqAnswer3:
      'The number of guests depends on your chosen plan. The Basic plan supports up to 100 guests, Professional up to 300, and Enterprise has unlimited guests.',
    faqQuestion4: 'How do I collect gift money through the platform?',
    faqAnswer4:
      "You can connect your Bit, Paybox, or other payment links to your event page. When guests confirm attendance, they'll be offered the option to send a gift through these payment methods.",
    faqQuestion5: 'How does the WhatsApp bot work?',
    faqAnswer5:
      'When you choose WhatsApp as your messaging channel, our automated bot sends each guest a WhatsApp message on your behalf and guides them through a natural conversation — asking whether they\'re attending, how many people are coming, and whether they need transport. At the end of the conversation, the bot also sends the event location as a Waze link.',
    faqQuestion6: 'Can I use both WhatsApp and SMS for the same event?',
    faqAnswer6:
      'No — you choose one channel for your entire event. If you go with WhatsApp, all guests are contacted through the WhatsApp bot. If you choose SMS, all guests receive a text message with a link to your event website. This keeps the experience consistent and seamless for every guest.',

    // Explanation Section
    howItWorksTitle: 'How It Works',
    step1Title: 'Upload Your Guest List',
    step1Text: "Provide us with your guests' phone numbers.",
    step2Title: 'Automated Messages',
    step2Text: 'We send each guest an SMS or WhatsApp message with RSVP links.',
    step3Title: 'Follow-Up',
    step3Text: "We automatically send a second reminder if they don't reply.",
    step4Title: 'AI Agent Call',
    step4Text:
      "If a guest still hasn't replied, our AI-powered system calls them to confirm.",
    step5Title: 'Event Info & Gifts',
    step5Text:
      'Guests get all event details, including location (Waze/Maps link) and gift options (PayBox, Bit, etc.).',
    explanationConclusion:
      'Our system saves you time and stress, letting you focus on enjoying your big day.',

    // Footer
    footerRights: '© 2025 Invitly. All rights reserved.',
    footerPrivacy: 'Privacy Policy',
    footerTerms: 'Terms of Service',
    footerContact: 'Contact',

    // Home Section
    homeWelcome: 'Welcome to Our RSVP Service!',
    homeIntro:
      "Tired of manually checking who's coming to your event? We automate it for you:",
    homeFeature1: 'Send SMS or WhatsApp reminders to all guests – twice.',
    homeFeature2:
      'AI agent phone call if no response – ensuring everyone is reached.',
    homeFeature3:
      'All the event details in one place (location with Waze/Maps link, gift options, etc.).',
    homeOutro:
      'Make sure every guest is informed and your planning is stress-free!',

    // Payment Component
    paymentTitle: 'Secured Payment',
    paymentAmount: 'Amount:',

    // PricingPlans Component
    ourPricingPlans: 'Our Pricing Plans',
    choosePlan: 'Get Started',
    contactForAddon: 'Add to My Plan',

    // SMS Plan
    smsPlanName: 'SMS',
    smsPlanTag: 'SMS + Website',
    smsPlanPrice: '₪229',
    smsPlanFeature1: 'Personalized SMS sent to each guest',
    smsPlanFeature2: 'Event website with Coming / Not Coming / Not Sure buttons',
    smsPlanFeature3: 'Write your own invitation & reminder text',
    smsPlanFeature4: 'Guest list dashboard & attendance tracking',
    smsPlanFeature5: 'AI phone calls for guests who haven\'t replied',

    // WhatsApp Plan
    whatsappPlanName: 'WhatsApp',
    whatsappPlanTag: 'WhatsApp Bot',
    whatsappPlanPrice: '₪259',
    whatsappPlanFeature1: 'WhatsApp bot contacts every guest — collects RSVP, guest count & transport',
    whatsappPlanFeature2: 'Sends event location as a Waze link',
    whatsappPlanFeature3: 'Guest list dashboard & attendance tracking',
    whatsappPlanFeature4: 'AI phone calls for guests who haven\'t replied',

    // WhatsApp Invitations Add-on
    whatsappAddonName: 'WhatsApp Invitations',
    whatsappAddonTag: 'Add-on',
    whatsappAddonPrice: '+ ₪49',
    whatsappAddonDesc: 'Want to send the invitation to everyone before, so they can save the date? We\'ll send a beautifully formatted WhatsApp message to your entire guest list.',

    // Legacy keys (kept for compatibility)
    basicPlan: 'SMS',
    basicPrice: '₪229',
    premiumPlan: 'WhatsApp',
    premiumPrice: '₪259',

    // Services Component
    servicesHeader: 'Our Services',
    service1Title: 'Send SMS',
    service1Desc: 'Send a congratulatory message to the couple.',
    service2Title: 'Automated RSVP calls',
    service2Desc: 'Schedule a call with the couple using AI.',
    service3Title: 'Send Present',
    service3Desc: "Choose a gift from the couple's registry.",
    service4Title: 'See Location',
    service4Desc: 'Get directions to the wedding venue.',
    service5Title: 'Monitor guest list',
    service5Desc: "View the couple's wedding invitation and RSVPs.",
    service6Title: 'Details',
    service6Desc: 'Find out more about the wedding day.',
    service7Title: 'WhatsApp Bot',
    service7Desc: 'An automated WhatsApp bot chats with every guest — collecting RSVP, number of attendees, and transport preference in a natural conversation.',

    // Register Component
    signUpTitle: 'Sign Up for Your Event',
    signUpSubtitle: 'How excited we are toward your upcoming event!',
    wifeName: 'Wife Name',
    wifeNameTooltip: "Enter the wife's first and last name",
    husbandName: 'Husband Name',
    husbandNameTooltip: "Enter the husband's first and last name",
    eventOrganizer: 'Event Organizer',
    eventOrganizerTooltip: 'First and last name of the event organizer',
    email: 'Email',
    emailTooltip: 'Enter a valid email address for communications',
    phoneNumber: 'Phone Number',
    phoneTooltip: 'Enter your phone number without country code',
    eventType: 'Event Type',
    eventTypeTooltip: "Select the type of event you're planning",
    wedding: 'Wedding',
    barMitzvah: 'Bar Mitzvah',
    batMitzvah: 'Bat Mitzvah',
    hina: 'Hina',
    jobEvent: 'Company Event',
    party: 'Party',
    birthday: 'Birthday',
    other: 'Other',
    nextStep: 'Next Step',
    prevStep: 'Previous',
    eventDetails: 'Event Details',
    googleMapLink: 'Google Map Link',
    googleMapTooltip: 'Paste a Google Maps link to your event location',
    eventDate: 'Event Date',
    eventDateTooltip: 'Select the date of your event',
    eventTime: 'Event Time',
    eventTimeTooltip: 'Select the start time of your event',
    uploadInvitation: 'Upload Invitation Image',
    uploadInvitationTooltip: 'Upload an image for your event invitation',
    selected: 'Selected',
    customizeMessages: 'Customize Your Messages',
    firstRsvpMessage: 'First RSVP message',
    firstRsvpTooltip:
      'Example: "Hey! Please confirm your attendance to our wedding through the link:"',
    tomorrowMessage: 'Day-before reminder message',
    tomorrowTooltip:
      'Example: "Hi! Just wanted to remind you about our wedding tomorrow. Looking forward to seeing you!"',
    reminderRsvpMessage: 'Reminder RSVP message',
    reminderRsvpTooltip:
      'Example: "Final reminder! Please confirm your attendance by clicking the link:"',
    afterWeddingMessage: 'After-Wedding thank-you',
    afterWeddingTooltip:
      'Example: "Thank you for celebrating with us! You were an unforgettable part of our special day ❤️"',
    paymentOptions: 'Payment Options',
    bitLink: 'Bit Link',
    bitLinkTooltip: 'Optional: Add a Bit payment link for your guests',
    payboxLink: 'Paybox Link',
    payboxLinkTooltip: 'Optional: Add a Paybox group link for your guests',
    createAccount: 'Create Your Account',
    accountSetup: 'Set up your account credentials',
    username: 'Username',
    usernameTooltip: 'Choose a username for your account',
    couponCode: 'Coupon Code',
    validateCoupon: 'Validate Coupon',
    validating: 'Validating...',
    couponValid: 'Coupon code is valid!',
    comingSoon: 'Coming Soon',
    password: 'Password',
    passwordTooltip: 'Choose a secure password (at least 8 characters)',
    confirmPassword: 'Confirm Password',
    confirmPasswordTooltip: 'Re-enter your password to confirm',
    passwordsDoNotMatch: 'Passwords do not match',
    paymentMethod: 'Payment Method',
    creditCard: 'Credit Card',
    paypal: 'PayPal',
    completeRegistration: 'Complete Registration',
    confirmationCode: 'Please enter the confirmation code',
    codeSentTo: 'A 6-digit code has been sent to',
    didntReceiveCode: "Didn't receive the code?",
    clickHere: 'Click here',
    resendCode: 'Resend code available in',
    seconds: 'seconds',
    cancel: 'Cancel',
    registrationSuccess: 'Registration Successful!',
    registrationSuccessMessage:
      'You have been registered successfully! You can go to your dashboard now!',
    goToDashboard: 'Go to Dashboard',

    // Coupon Modal
    couponModalTitle: 'Do you have a coupon code?',
    couponModalSubtitle: 'If you have a coupon code, click "Yes" to proceed to registration. Otherwise, contact us on WhatsApp to learn more!',
    yesIHaveCoupon: 'Yes, I have a coupon',
    noContactWhatsApp: 'No, contact me on WhatsApp',

    // PayMe Checkout
    payWithCard: 'Pay with Credit Card',
    cardNumber: 'Card Number',
    expiration: 'Expiration',
    cvc: 'CVC',
    processing: 'Processing...',
    pay: 'Pay',
    generatingSale: 'Generating sale...',
    processingPayment: 'Processing payment...',
    paymentSuccessful: 'Payment Successful!',
    paymentFailed: 'Payment Failed',
    tokenizingCard: 'Tokenizing card data...',
    paymentSystemError: 'Error initializing payment system.',
    paymentSystemNotInit: 'Payment system not initialized',
    applePay: 'Apple Pay',
    googlePay: 'Google Pay',
    fullName: 'Full Name',
    socialId: 'ID Number',
    phoneNumberShort: 'Phone',
    emailShort: 'Email',
  },
  he: {
    // Header
    home: 'ראשי',
    services: 'שירותים',
    testimonials: 'המלצות',
    pricing: 'מחירים',
    faq: 'שאלות נפוצות',
    login: 'התחברות',
    signup: 'הרשמה',
    language: 'English',
    personalArea: 'איזור אישי',

    // Hero Section
    heroTitle: 'אישורי הגעה לכל אירוע !',
    heroSubtitle: 'אל תבזבזו זמן וכסף, תבחרו בנו לנהל לכם את אישורי ההגעה',
    getStarted: 'התחל עכשיו',
    learnMore: 'למידע נוסף',

    // Services Section
    servicesTitle: 'השירותים שלנו',
    serviceRSVP: 'ניהול אישורי הגעה',
    serviceRSVPDesc: 'מעקב אחר תגובות אורחים וניהול נוכחות בקלות',
    serviceCommunication: 'תקשורת עם אורחים',
    serviceCommunicationDesc: 'שליחת הודעות לאורחים לפני ואחרי האירוע',
    serviceGifts: 'רשימת מתנות דיגיטלית',
    serviceGiftsDesc: 'ניהול אפשרויות מתנה ואמצעי תשלום לאירוע שלך',
    serviceAnalytics: 'ניתוח נתוני אורחים',
    serviceAnalyticsDesc: 'קבלת תובנות על האורחים שלך והעדפותיהם',

    // Testimonials
    testimonialsTitle: 'מה הלקוחות שלנו אומרים',
    testimonial1Text: '"שירות תכנון חתונה הכי מדהים. הכל היה מושלם!"',
    testimonial1Author: '- שרה ומיכאל',
    testimonial2Text:
      '"אהבנו כמה קל היה לעקוב אחר אישורי ההגעה. המערכת האוטומטית חסכה לנו כל כך הרבה זמן!"',
    testimonial2Author: '- דוד ואמילי',
    testimonial3Text:
      '"האורחים שלנו התרשמו מכמה חלק היה תהליך אישור ההגעה. ממליצים בחום!"',
    testimonial3Author: '- רחל ויעקב',

    // Pricing
    pricingTitle: 'בחר את התכנית שלך',
    basic: 'בסיסי',
    pro: 'מקצועי',
    enterprise: 'עסקי',
    monthly: 'חודשי',
    priceFree: 'חינם',
    priceBasic: '₪99',
    pricePro: '₪349',
    perMonth: '/חודש',
    getStartedNow: 'התחל עכשיו',
    contactUs: 'צור קשר',

    // Join Section
    joinTitle: 'מוכנים לפשט את תכנון האירוע שלכם?',
    joinSubtitle: 'הירשמו היום והתחילו לנהל את רשימת האורחים שלכם ללא מאמץ',
    joinButton: 'הצטרפו עכשיו',

    // FAQ
    faqTitle: 'שאלות נפוצות',
    faqQuestion1: 'איך עובדת מערכת אישורי ההגעה?',
    faqAnswer1:
      'בין אם בחרתם SMS ובין אם WhatsApp, כל התשובות מתאספות אצלכם בדשבורד — טבלת אורחים עם מי מגיע, מי לא ומי עדיין לא ענה, לצד גרף עוגה שמראה את החלוקה. בקשות מיוחדות כמו הסעה מופיעות שם גם הן.',
    faqQuestion2: 'האם אני יכול להתאים אישית את הודעת ההזמנה?',
    faqAnswer2:
      'ב-SMS כן — אפשר לערוך את הטקסט של ההודעות שנשלחות לאורחים. ב-WhatsApp הבוט מנהל שיחה לפי תסריט קבוע, ולכן הניסוח אינו ניתן לעריכה.',
    faqQuestion3: 'האם יש הגבלה למספר האורחים שאני יכול להזמין?',
    faqAnswer3:
      'אין הגבלה למספר האורחים, התעריף ישתנה לפי מספר האורחים',
    //       faqQuestion4: 'איך אני אוסף כסף למתנות דרך הפלטפורמה?',
    // faqAnswer4:
    //   'אתה יכול לחבר את קישורי התשלום שלך מביט, פייבוקס או שיטות תשלום אחרות לדף האירוע שלך. כאשר אורחים מאשרים הגעה, תוצע להם האפשרות לשלוח מתנה דרך שיטות תשלום אלה.',
    faqQuestion4: 'מה מופיע בלינק שהאורחים מקבלים בSMS?',
    faqAnswer4: 'האורחים מקבלים לינק עם פרטי האירוע, תמונת ההזמנה, אפשרות לאשר הגעה, לבחור בהסעה, לפתוח waze ו google maps. הכל בממשק נוח !',
    faqQuestion5: 'איך עובד בוט ה-WhatsApp?',
    faqAnswer5:
      'כשבוחרים WhatsApp כערוץ התקשורת, הבוט שולח לכל אורח הודעת WhatsApp בשמכם ומנהל איתו שיחה טבעית — שואל אם הוא מגיע, כמה אנשים יבואו, ואם הוא זקוק להסעה. בסיום השיחה, הבוט שולח גם קישור Waze למיקום האירוע.',
    faqQuestion6: 'האם אפשר לשלוח חלק מהאורחים ב-WhatsApp וחלק ב-SMS?',
    faqAnswer6:
      'לא — בוחרים ערוץ אחד לכל האירוע. אם בחרתם WhatsApp, כל האורחים יקבלו הודעה מהבוט. אם בחרתם SMS, כל האורחים יקבלו הודעת טקסט עם קישור לאתר האירוע. כך נשמרת חוויה אחידה ועקבית לכל האורחים.',

    // Explanation Section
    howItWorksTitle: 'איך זה עובד',
    step1Title: 'העלאת רשימת האורחים',
    step1Text: 'ספק לנו את מספרי הטלפון של האורחים שלך.',
    step2Title: 'הודעות אוטומטיות',
    step2Text: 'אנו שולחים לכל אורח הודעת SMS או WhatsApp עם קישורי RSVP.',
    step3Title: 'מעקב',
    step3Text: 'אנו שולחים באופן אוטומטי תזכורת שנייה אם הם לא עונים.',
    step4Title: 'שיחת בינה מלאכותית',
    step4Text:
      'אם אורח עדיין לא הגיב, המערכת שלנו מבוססת הבינה המלאכותית מתקשרת אליו לאישור.',
    step5Title: 'פרטי האירוע ומתנות',
    step5Text:
      "האורחים מקבלים את כל פרטי האירוע, כולל מיקום (קישור Waze/Maps) ואפשרויות למתנות (PayBox, Bit וכו').",
    explanationConclusion:
      'המערכת שלנו חוסכת לך זמן ולחץ, ומאפשרת לך להתמקד בהנאה מהיום הגדול שלך.',

    // Footer
    footerRights: '© 2025 Invitly. כל הזכויות שמורות.',
    footerPrivacy: 'מדיניות פרטיות',
    footerTerms: 'תנאי שימוש',
    footerContact: 'צור קשר',

    // Home Section
    homeWelcome: 'ברוכים הבאים לשירות האישורי הגעה שלנו!',
    homeIntro:
      'עייפים מלבדוק ידנית מי מגיע לאירוע שלכם? אנחנו מאפשרים זאת באופן אוטומטי עבורכם:',
    homeFeature1: 'שליחת תזכורות SMS או WhatsApp לכל האורחים – פעמיים.',
    homeFeature2:
      'שיחת סוכן בינה מלאכותית אם אין תגובה – מבטיחה שמגיעים לכולם.',
    homeFeature3:
      "כל פרטי האירוע במקום אחד (מיקום עם קישור Waze/מפות, אפשרויות למתנות וכו').",
    homeOutro: 'ודאו שכל אורח מעודכן והתכנון שלכם הוא ללא לחץ!',

    // Payment Component
    paymentTitle: 'תשלום מאובטח',
    paymentAmount: 'סכום:',

    // PricingPlans Component
    ourPricingPlans: 'תוכניות המחירים שלנו',
    choosePlan: 'התחילו עכשיו',
    contactForAddon: 'הוסף לתוכנית שלי',

    // SMS Plan
    smsPlanName: 'SMS',
    smsPlanTag: 'SMS + אתר',
    smsPlanPrice: '₪229',
    smsPlanFeature1: 'SMS אישי לכל אורח',
    smsPlanFeature2: 'אתר אירוע עם כפתורות מגיע / לא מגיע / לא יודע',
    smsPlanFeature3: 'כתבו את טקסט ההזמנה והתזכורת בעצמכם',
    smsPlanFeature4: 'דשבורד ניהול אורחים ומעקב נוכחות',
    smsPlanFeature5: 'שיחות טלפון על ידי סוכן AI לאורחים שלא ענו',

    // WhatsApp Plan
    whatsappPlanName: 'WhatsApp',
    whatsappPlanTag: 'בוט WhatsApp',
    whatsappPlanPrice: '₪259',
    whatsappPlanFeature1: 'בוט WhatsApp מתקשר עם כל אורח — אוסף אישור, מספר אנשים והסעה',
    whatsappPlanFeature2: 'שולח את מיקום האירוע כקישור Waze',
    whatsappPlanFeature3: 'דשבורד ניהול אורחים ומעקב נוכחות',
    whatsappPlanFeature4: 'שיחות טלפון על ידי סוכן AI לאורחים שלא ענו',

    // WhatsApp Invitations Add-on
    whatsappAddonName: 'הזמנות WhatsApp',
    whatsappAddonTag: 'תוספת',
    whatsappAddonPrice: '+ ₪49',
    whatsappAddonDesc: 'רוצים לשלוח את ההזמנה לכולם מראש, כדי שיוכלו לשמור את התאריך? אנחנו נשלח הודעת WhatsApp מעוצבת לכל רשימת האורחים שלכם.',

    // Legacy keys (kept for compatibility)
    basicPlan: 'SMS',
    basicPrice: '₪229',
    premiumPlan: 'WhatsApp',
    premiumPrice: '₪259',
    premiumFeature1: 'כל מה שבבסיסי',
    premiumFeature2: 'תבניות מותאמות אישית',
    premiumFeature3: 'שליחת הזמנה ראשונה בWhatsApp',
    premiumPlusFeature1: 'כל מה שבפרימיום',
    premiumPlusFeature2: 'אתר חתונה',
    premiumPlusFeature3: 'תרשים ישיבה',
    premiumPlusFeature4: 'מתכנן תקציב',
    premiumPlusFeature5: 'ניהול לוח זמנים',

    // Services Component
    servicesHeader: 'השירותים שלנו',
    service1Title: 'שליחת SMS',
    service1Desc: 'שליחה אוטומטית של הודעות לאורחים, עם לינק לאתר בו יוכלו לאשר הגעה.',
    service2Title: 'שיחות טלפון',
    service2Desc: 'שיחות של סוכנת AI לאורחים שלא אישרו הגעה.',
    service3Title: 'שלח מתנה',
    service3Desc: 'אפשרות לאורחים לשלוח מתנה דרך קישור תשלום.',
    service4Title: 'צפה במיקום',
    service4Desc: 'האורחים יקבלו הוראות הגעה למקום החתונה.',
    service5Title: 'מעקב אחר רשימת אורחים',
    service5Desc: 'ממשק נוח לניהול רשימת אורחים, חילוק לקבוצות ועדכון סטטוס אישורי הגעה.',
    service6Title: 'הוספת אפשרויות הסעה',
    service6Desc: 'נשאל את האורחים שמגיעים אם הם מעוניינים להסעה לאירוע, וניצור עבורכם רשימה מסודרת.',
    service7Title: 'בוט WhatsApp',
    service7Desc: 'בוט WhatsApp אוטומטי מנהל שיחה עם כל אורח — אישור הגעה, מספר משתתפים ובחירת הסעה, הכל בשיחה טבעית.',

    // Register Component
    signUpTitle: 'הירשמו לאירוע שלכם',
    signUpSubtitle: 'כמה אנחנו נרגשים לקראת האירוע הקרב שלכם!',
    wifeName: 'שם הכלה',
    wifeNameTooltip: 'הזן את השם הפרטי ושם המשפחה של הכלה',
    husbandName: 'שם החתן',
    husbandNameTooltip: 'הזן את השם הפרטי ושם המשפחה של החתן',
    eventOrganizer: 'שם המארגן/ת',
    eventOrganizerTooltip: 'שם פרטי ושם משפחה של מארגן האירוע',
    email: 'אימייל',
    emailTooltip: 'הזן כתובת אימייל תקפה לתקשורת',
    phoneNumber: 'מספר טלפון',
    phoneTooltip: 'הזן את מספר הטלפון שלך ללא קידומת',
    eventType: 'סוג אירוע',
    eventTypeTooltip: 'בחר את סוג האירוע שאתה מתכנן',
    wedding: 'חתונה',
    barMitzvah: 'בר מצווה',
    batMitzvah: 'בת מצווה',
    hina: 'חינה',
    jobEvent: 'אירוע חברה',
    party: 'מסיבה',
    birthday: 'יום הולדת',
    other: 'אחר',
    nextStep: 'לשלב הבא',
    prevStep: 'הקודם',
    eventDetails: 'פרטי האירוע',
    googleMapLink: 'קישור למפת גוגל',
    googleMapTooltip: 'חפש את כתובת האירוע בGoogle Maps, לחץ על שיתוף, העתק והדבק את הקישור ',
    eventDate: 'תאריך האירוע',
    eventDateTooltip: 'בחר את תאריך האירוע שלך',
    eventTime: 'זמן האירוע',
    eventTimeTooltip: 'בחר את שעת התחלת האירוע שלך',
    uploadInvitation: 'העלאת תמונת הזמנה',
    uploadInvitationTooltip: 'העלה תמונה להזמנה לאירוע שלך',
    selected: 'נבחר',
    customizeMessages: 'התאם את ההודעות שלך',
    firstRsvpMessage: 'הודעה ראשונה לאישור הגעה',
    firstRsvpTooltip: 'דוגמה: "היי! נשמח לאשר את הגעתכם לחתונתנו דרך הקישור:"',
    tomorrowMessage: 'הודעת תזכורת יום לפני האירוע ',
    tomorrowTooltip: 'דוגמה: "היי! רק רצינו להזכיר לכם את החתונה מחר. נשמח לראותכם!"',
    reminderRsvpMessage: 'הודעה לאישור הגעה לאורחים שעדיין לא ענו',
    reminderRsvpTooltip:
      'דוגמה: "תזכורת אחרונה! אנא אשרו הגעה בלחיצה על הקישור:"',
    afterWeddingMessage: 'תודה אחרי החתונה',
    afterWeddingTooltip:
      'דוגמה: "תודה שחגגתם איתנו! הייתם חלק בלתי נשכח מהיום המיוחד שלנו ❤️"',
    paymentOptions: 'אפשרויות תשלום',
    bitLink: 'קישור לביט',
    bitLinkTooltip: 'אופציונלי: הוסף קישור תשלום Bit לאורחים שלך',
    payboxLink: 'קישור פייבוקס',
    payboxLinkTooltip: 'אופציונלי: הוסף קישור קבוצתי של Paybox לאורחים שלך',
    createAccount: 'צור את החשבון שלך',
    accountSetup: 'הגדרת פרטי התחברות לחשבון',
    username: 'שם משתמש',
    usernameTooltip: 'בחר שם משתמש לחשבון שלך',
    couponCode: 'קוד קופון',
    validateCoupon: 'אמת קופון',
    validating: 'מאמת...',
    couponValid: 'קוד הקופון תקין!',
    comingSoon: 'בקרוב',
    password: 'סיסמה',
    passwordTooltip: 'בחר סיסמה מאובטחת (לפחות 8 תווים)',
    confirmPassword: 'אשר סיסמה',
    confirmPasswordTooltip: 'הזן שוב את הסיסמה שלך לאישור',
    passwordsDoNotMatch: 'הסיסאות אינן תואמות',
    paymentMethod: 'אמצעי תשלום',
    creditCard: 'כרטיס אשראי',
    paypal: 'פייפאל',
    completeRegistration: 'השלם הרשמה',
    confirmationCode: 'אנא הזן את קוד האישור',
    codeSentTo: 'קוד בן 6 ספרות נשלח אל',
    didntReceiveCode: 'לא קיבלת את הקוד?',
    clickHere: 'לחץ כאן',
    resendCode: 'שליחת קוד חוזרת תהיה זמינה בעוד',
    seconds: 'שניות',
    cancel: 'ביטול',
    registrationSuccess: 'ההרשמה הושלמה בהצלחה!',
    registrationSuccessMessage:
      'נרשמת בהצלחה! אתה יכול לעבור ללוח הבקרה שלך עכשיו!',
    goToDashboard: 'עבור ללוח הבקרה',

    // Coupon Modal
    couponModalTitle: 'האם יש לך קוד קופון?',
    couponModalSubtitle: 'אם יש לך קוד קופון, לחץ על "כן" כדי להמשיך להרשמה. אחרת, צור איתנו קשר בווטסאפ כדי לגלות עוד!',
    yesIHaveCoupon: 'כן, יש לי קופון',
    noContactWhatsApp: 'לא, צור איתי קשר בווטסאפ',

    // PayMe Checkout
    payWithCard: 'תשלום בכרטיס אשראי',
    cardNumber: 'מספר כרטיס',
    expiration: 'תאריך תפוגה',
    cvc: 'CVC',
    processing: 'מעבד...',
    pay: 'שלם',
    generatingSale: 'מייצר מכירה...',
    processingPayment: 'מעבד תשלום...',
    paymentSuccessful: 'התשלום בוצע בהצלחה!',
    paymentFailed: 'שגיאה בתשלום',
    tokenizingCard: 'ממיר נתוני כרטיס...',
    paymentSystemError: 'שגיאה בהפעלת מערכת התשלום.',
    paymentSystemNotInit: 'מערכת התשלום לא הופעלה',
    applePay: 'תשלום באפל פיי',
    googlePay: 'תשלום בגוגל פיי',
    fullName: 'שם מלא',
    socialId: 'תעודת זהות',
    phoneNumberShort: 'טלפון',
    emailShort: 'מייל לקבלה',
  },
}
